module.exports = __webpack_public_path__ + "img/2.6_Indigenous-Advisory-Group_3_Perry.ac1218be68fcd2a59b917b29c6487677.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.6_Indigenous-Advisory-Group_3_Perry.jpg
// module id = 788
// module chunks = 0